/** Validate the complete backend-owned copy contract at the network boundary. */
import type { Copy } from "../../server/copy";
import { object } from "./core/workspace";
const keys = [
  "intro",
  "introAccent",
  "introText",
  "byServarium",
  "localVideo",
  "privateDrafts",
  "signInTitle",
  "signInText",
  "signUpText",
  "recoveryTitle",
  "recoveryText",
  "sendReset",
  "newReset",
  "toSignIn",
  "noAccount",
  "hasAccount",
  "or",
  "showPassword",
  "hidePassword",
  "checkEmail",
  "emailDestination",
  "editEmail",
  "verificationNext",
  "emailHelp",
  "emailResent",
  "invalidResetTitle",
  "resetText",
  "resetComplete",
  "resetCompleteText",
  "passkeyHelp",
  "passkeyFailed",
  "passkeyDescription",
  "passkeyLoadFailed",
  "passkeyDefault",
  "confirmPasskeyDelete",
  "sessionsRevoked",
  "security",
  "accountText",
  "accessHelp",
  "themeLight",
  "themeDark",
  "home",
  "retry",
  "signIn",
  "signUp",
  "email",
  "password",
  "name",
  "passwordHint",
  "forgotten",
  "passkey",
  "verificationSent",
  "recoverySent",
  "resend",
  "pendingTitle",
  "pendingText",
  "suspended",
  "rejected",
  "refresh",
  "projects",
  "account",
  "administration",
  "logout",
  "emptyProjects",
  "emptyHint",
  "newProject",
  "open",
  "duplicate",
  "rename",
  "remove",
  "confirmDelete",
  "cancel",
  "save",
  "projectName",
  "copySuffix",
  "back",
  "pickSource",
  "sourceMismatch",
  "saved",
  "saving",
  "pendingSave",
  "offlineSave",
  "conflict",
  "keepCopy",
  "useServer",
  "localUnavailable",
  "recovered",
  "requestFailed",
  "noSession",
  "balance",
  "unlimited",
  "remaining",
  "used",
  "held",
  "minutes",
  "month",
  "resetAt",
  "managed",
  "custom",
  "managedHint",
  "managedBusy",
  "noWords",
  "passkeys",
  "addPasskey",
  "passkeyName",
  "passkeyAdded",
  "noPasskeys",
  "passwordChange",
  "currentPassword",
  "newPassword",
  "passwordChanged",
  "resetPassword",
  "invalidReset",
  "pending",
  "approved",
  "user",
  "admin",
  "status",
  "role",
  "approve",
  "reject",
  "suspend",
  "restore",
  "settings",
  "unlimitedLabel",
  "remainingLabel",
  "monthlyLabel",
  "settingsSaved",
  "unverified",
  "next",
  "previous",
  "noUsers",
  "processing",
  "loading",
  "privacy",
] as const satisfies readonly (keyof Copy)[];
// Adding backend copy requires extending this validator, checked at compile time.
const complete: Exclude<keyof Copy, typeof keys[number]> extends never ? true : never = true;
export function parseCopy(value: unknown): Copy | null {
  const row = object(value);
  if (!complete || !row || keys.some((key) => typeof row[key] !== "string")) return null;
  return row as Copy; // Every property has been checked above.
}
